import styled from 'styled-components';
import device from '../../utils/device';

const Desktop = styled.div`
  @media ${device.mobile} {
     display: flex;     
  }
  display: none;  
`;

const Mobile = styled.div`
  @media ${device.mobile} {
     display: none;
  }
  display: block;
  
`;

export {Desktop, Mobile};

